export function uuid(): string {
  // Generate a V4 UUID using a cryptographically secure random number generator.
  return crypto.randomUUID()
}
